// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Block3_wrapper__NJ1Rw"};